import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'
import { ILayoutState } from '@/store/types'
import store from '@/store'
import { DownloadProgress } from '@/utils/electron'

@Module({ dynamic: true, store: store, namespaced: true, name: 'layout' })
export default class LayoutModule extends VuexModule implements ILayoutState {
  progressBarVisible: boolean = false
  teamTokenDialogVisible: boolean = false
  defaultTeamToken: string = ''
  searchDialogVisible: boolean = false
  updateDownloadProgress: DownloadProgress | null = null

  // LFG modal
  tournamentLFGModalVisible: boolean = false
  selectedLFGModalTournamentTeamId: string = ''

  // Global progress bar
  @Mutation
  SET_PROGRESS_BAR_VISIBLE(visible: boolean) {
    this.progressBarVisible = visible
  }

  @Action
  setProgressBarVisible(visible: boolean) {
    this.context.commit('SET_PROGRESS_BAR_VISIBLE', visible)
  }

  /* Team Token Dialog */
  @Mutation
  SET_TEAM_TOKEN_DIALOG_VISIBLE(state: {
    visible: boolean
    defaultTeamToken: string
  }) {
    this.teamTokenDialogVisible = state.visible
    this.defaultTeamToken = state.defaultTeamToken
  }

  @Action
  setTeamTokenDialogVisible(visible: boolean) {
    this.context.commit('SET_TEAM_TOKEN_DIALOG_VISIBLE', {
      visible,
      defaultTeamToken: ''
    })
  }

  @Action
  showTeamTokenDialogWithDefaultToken(defaultTeamToken: string) {
    this.context.commit('SET_TEAM_TOKEN_DIALOG_VISIBLE', {
      visible: true,
      defaultTeamToken
    })
  }

  get isTeamTokenDialogVisible() {
    return this.teamTokenDialogVisible
  }

  // Search dialog
  @Mutation
  SET_SEARCH_DIALOG_VISIBLE(visible: boolean) {
    this.searchDialogVisible = visible
  }

  @Action
  setSearchDialogVisible(visible: boolean) {
    this.context.commit('SET_SEARCH_DIALOG_VISIBLE', visible)
  }

  get isSearchDialogVisible() {
    return this.searchDialogVisible
  }

  // Update download progress
  @Mutation
  SET_UPDATE_DOWNLOAD_PROGRESS(progress: DownloadProgress | null) {
    this.updateDownloadProgress = progress
  }

  @Action
  setUpdateDownloadProgress(progress: DownloadProgress | null) {
    this.context.commit('SET_UPDATE_DOWNLOAD_PROGRESS', progress)
  }

  // LFG Modal
  @Mutation
  SET_LFG_MODAL(tournamentTeamId: string) {
    this.selectedLFGModalTournamentTeamId = tournamentTeamId
    this.tournamentLFGModalVisible = tournamentTeamId !== null
  }

  @Action
  showLFGModal(tournamentTeamId: string) {
    this.context.commit('SET_LFG_MODAL', tournamentTeamId)
  }

  @Action
  hideLFGModal() {
    this.context.commit('SET_LFG_MODAL', null)
  }
}
